import { h, JSX } from 'preact';
import ObservingComponent from '../../componentBases/observingComponent';
import MeetingsBoldReportPageProps from './meetingsBoldReportPageProps';
import { BoldReportsViewer } from '../../boldReportsViewer';
import 'preact/compat';
import { BoldReportsReportViewerPage, MeetingsBoldReportPageActions } from 'core.frontend';
import Button from '../../buttons/button';

var viewerStyle = {'height': '700px', 'width': '100%'};

function formatDate(input: Date | string): string {
    const date = new Date(input);
    const mm = String(date.getMonth() + 1).padStart(2, '0');
    const dd = String(date.getDate()).padStart(2, '0');
    const yyyy = date.getFullYear();
    return `${mm}/${dd}/${yyyy}`;
}

function formatTime(input: string): string {
    const [h = '00', m = '00'] = input.split(':');
    return `${h.padStart(2, '0')}:${m.padStart(2, '0')}`;
}

class MeetingsBoldReportPage extends ObservingComponent<MeetingsBoldReportPageProps> {

    public componentWillMount(): void {
        this.registerUpdateObserver(this.props.page.observationProvider, MeetingsBoldReportPageActions.LoadedBoldReportsViewer);
    }

    
    public render({ page }: MeetingsBoldReportPageProps): JSX.Element {  
        const { api, currentUserManager, reportOptions } = page;
          
        const options = {
            reportId: 'MeetingAttendeeReport.rdl',
             reportParams : [
                { name: 'EventId', values: [String(reportOptions.eventId)] },
                { name: 'StartDate', values: [formatDate(reportOptions.startDate)] },
                { name: 'StartTime', values: [formatTime(reportOptions.startTime)] },
                { name: 'EndDate', values: [formatDate(reportOptions.endDate)] },
                { name: 'EndTime', values: [formatTime(reportOptions.endTime)] },
                { name: 'ReportForType', values: [String(reportOptions.reportForType)] },
                { name: 'CancellationStatus', values: [String(reportOptions.cancellationStatus)] },
                { name: 'EventAttendeeIds', values: reportOptions.eventAttendeeIds.map(String) },
                ...(reportOptions.defaultMeetingCategoryId !== undefined
                    ? [{ name: 'DefaultMeetingCategoryId', values: [String(reportOptions.defaultMeetingCategoryId)] }]
                    : []),
                ...(reportOptions.attendeeBusinessAreaId !== undefined
                    ? [{ name: 'AttendeeBusinessAreaId', values: [String(reportOptions.attendeeBusinessAreaId)] }]
                    : []),
                ...(reportOptions.attendeeDepartmentId !== undefined
                    ? [{ name: 'AttendeeDepartmentId', values: [String(reportOptions.attendeeDepartmentId)] }]
                    : []),
                ...(reportOptions.venueId !== undefined
                    ? [{ name: 'VenueId', values: [String(reportOptions.venueId)] }]
                    : []),
                ...(reportOptions.scheduledById !== undefined
                    ? [{ name: 'ScheduledById', values: [String(reportOptions.scheduledById)] }]
                    : []),
                ...(reportOptions.guestsArrived !== undefined
                    ? [{ name: 'GuestsArrived', values: [String(reportOptions.guestsArrived)] }]
                    : []),
                { name: 'IncludeTransportation', values: [String(reportOptions.includeTransportation)] }
            ]
        };

        const reportViewerPage = new BoldReportsReportViewerPage(api, currentUserManager, options);
    
        return (        
            <div class="report">
                <div class="flex">
                    <Button
                        className="mr-auto btn-icon"
                        button={page.backButton} />
                </div>
                <div>
                    <BoldReportsViewer page={reportViewerPage}></BoldReportsViewer>
                </div>
            </div>
          );
    }
}

export default MeetingsBoldReportPage;
